// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `fi-checkbox-list {
  padding-bottom: 10px;
  max-height: 240px;
}
fi-checkbox-list .mat-mdc-checkbox .mdc-form-field label {
  max-width: unset;
}`, "",{"version":3,"sources":["webpack://./Source/app/external-platform-integration/ad-integration/ad-import/ad-import-choose-groups-dialog/ad-import-choose-groups-dialog.component.scss"],"names":[],"mappings":"AAAA;EACI,oBAAA;EACA,iBAAA;AACJ;AAAI;EACI,gBAAA;AAER","sourcesContent":["fi-checkbox-list {\r\n    padding-bottom: 10px;\r\n    max-height: 240px;\r\n    .mat-mdc-checkbox .mdc-form-field label {\r\n        max-width: unset;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
